// src/components/NetworkError.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { WifiOff, RefreshCw } from 'lucide-react';

interface NetworkErrorProps {
  onRetry?: () => void;
}

const NetworkError: React.FC<NetworkErrorProps> = ({ onRetry }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="fixed inset-0 bg-[#0a0a0f] backdrop-blur-xl z-[9999] flex items-center justify-center"
    >
      <div className="text-center max-w-md px-6">
        <div className="relative mb-6">
          <div className="absolute inset-0 bg-red-500/20 rounded-full blur-2xl animate-pulse" />
          <div className="relative w-24 h-24 mx-auto bg-gradient-to-br from-red-500/20 to-orange-500/20 rounded-full flex items-center justify-center border border-red-500/30">
            <WifiOff className="w-12 h-12 text-red-400 animate-pulse" />
          </div>
        </div>
        
        <h2 className="text-white font-rajdhani font-bold text-2xl mb-2">
          Connection Lost
        </h2>
        
        <p className="text-gray-400 mb-6">
          Please check your internet connection and try again.
        </p>
        
        {onRetry && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onRetry}
            className="px-8 py-3 bg-gradient-to-r from-purple-500 to-blue-500 rounded-xl text-white font-rajdhani font-bold flex items-center gap-2 mx-auto"
          >
            <RefreshCw className="w-4 h-4" />
            Retry Connection
          </motion.button>
        )}
      </div>
    </motion.div>
  );
};

export default NetworkError;